import React, { useEffect } from "react";
import { Spin } from "antd";
import { getOAuthAuthorizeUrl } from "../../services/integrations/klaviyoSubscriptionService";

/**
 * Dedicated install URL for Klaviyo marketplace.
 * Redirects directly into the OAuth authorize flow.
 * If the user isn't logged in, MainLayoutRoute handles the login redirect first,
 * then this page picks up and initiates OAuth.
 */
export default function KlaviyoInstall() {
  useEffect(() => {
    getOAuthAuthorizeUrl().then(url => {
      window.location.href = url;
    }).catch(() => {
      // Fallback to the integration page if OAuth URL fails
      window.location.href = "/integration";
    });
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
      <Spin size="large" tip="Connecting to Klaviyo..." />
    </div>
  );
}
